/**
 * Asserts that `value` is truthy.
 */
export function assert(value, message) {
    if (!value) {
        throw typeof message === 'object' ? message : new Error(message !== null && message !== void 0 ? message : `Expected ${value} to be truthy`);
    }
}
/**
 * Asserts that `actual` and `expected` are equal as determined by `Object.is()`.
 */
export function assertEqual(actual, expected, message) {
    if (!Object.is(actual, expected)) {
        throw typeof message === 'object' ? message : new Error(message !== null && message !== void 0 ? message : `Expected ${actual} to be ${expected}`);
    }
}
/**
 * Asserts that `value` is not `null` or `undefined`.
 */
export function assertIsDefined(value, message) {
    if (value === null || value === undefined) {
        throw typeof message === 'object' ? message : new Error(message !== null && message !== void 0 ? message : `Expected ${value} to be defined`);
    }
}
